var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_11742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49935 0.916504C2.96935 0.916504 0.916016 2.96984 0.916016 5.49984C0.916016 8.02984 2.96935 10.0832 5.49935 10.0832C8.02935 10.0832 10.0827 8.02984 10.0827 5.49984C10.0827 2.96984 8.02935 0.916504 5.49935 0.916504ZM4.25727 7.46609L2.61185 5.82067C2.4331 5.64192 2.4331 5.35317 2.61185 5.17442C2.7906 4.99567 3.07935 4.99567 3.2581 5.17442L4.58268 6.49442L7.73601 3.34109C7.91476 3.16234 8.20352 3.16234 8.38227 3.34109C8.56102 3.51984 8.56102 3.80859 8.38227 3.98734L4.90352 7.46609C4.72935 7.64484 4.43602 7.64484 4.25727 7.46609Z",
    fill: "#7BB728"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_11742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStatusIcon);
export default __webpack_public_path__ + "static/media/active_status_icon.8119939484d9b47e3e09858a2daf61c1.svg";
export { ForwardRef as ReactComponent };